<template lang="pug">
v-container.action-roles
  v-row(v-if="loading")
    v-col(cols="6")
      v-card
        v-skeleton-loader(
          class="mx-auto my-3"
          type="article"
        )
    v-col(cols="6")
      v-card
        v-skeleton-loader(
          class="mx-auto my-3"
          type="article"
        )
  v-row(v-else)
    v-col(cols="12")
      v-data-iterator(
        :items="groupedActions",
        :items-per-page.sync="itemsPerPage",
        :footer-props="{ showFirstLastPage: true, showCurrentPage: true }",
        :search="search",
      )
        template(v-slot:header="props")
          v-text-field(v-model="search", solo, clearable, hide-details, prepend-inner-icon="mdi-magnify", label='Search')
        template(v-slot:default="{ items }")
          masonry(
            :cols="2"
            :gutter="30"
          )
            template(v-for="group in items")
              transition(name="fade")
                v-card.mt-5(
                  :key="group.category",
                  elevation=5,
                )
                  v-card-title {{ group.category.replace(/_/g, " ") }}
                  v-card-text
                    .permission(v-for="(action, itemIndex) in group.items", :key="itemIndex")
                      v-tooltip(top, left)
                        template(v-slot:activator="{ on }")
                          .permissionCheck(v-on="on")
                            v-checkbox(
                              @change="handleInput($event, action, group.category, itemIndex)"
                              :label="action._Name",
                              :input-value="action.checked",
                            )
                        span {{ action._Name }}
                        br
                        span {{ action.source }}
</template>

<style lang="scss" scoped>
.action-roles {
  ::v-deep .permission {
    overflow-wrap: anywhere;
  }

  .fade-enter-active, .fade-leave-active {
    transition: all 0.5s ease;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(10px);
  }
}
</style>

<script>
import EntityMixin from '@/mixins'
import axios from 'axios'

export default {
  mixins: [EntityMixin],
  props: ['path', 'entity'],
  data () {
    return {
      loading: true,
      actions: [],

      itemsPerPage: 10,
      groupedActions: [],
      search: '',
    }
  },
  computed: {},
  methods: {
    groupActions(actions) {
      return _.chain(actions)
        .map(x => {
          return { ...x, checked: this.foundInInstance(x.id) }
        })
        .groupBy(val => val.section)
        .map((items, category) => {
          return ({ items, category })
        })
        .value();
    },
    handleInput(evt, { id }, groupCategory, itemIndex) {
      // console.log('EVT ', evt)
      // console.log('Action ', id)
      // console.log('INDEX G ', groupCategory);
      // console.log('INDEX I ', itemIndex);
      let actionIndex = _.findIndex(this.instance.filter(x => x.deletedAt == null), ['actionId', id]);
      let groupIndex = _.findIndex(this.groupedActions, ['category', groupCategory]);
      // console.log('GROUPINDEX ', groupIndex)
      // console.log('AIndex', actionIndex);
      if (actionIndex === -1) {
        if(evt) {
          // Add to array with entityState 4
          // TODO: Can t just push bcs set instance on entity list is made when entity is rendered
          this.$store.commit('SET_INSTANCE_PATH', {
            path: `${this.path}[${this.instance.length}]`,
            value: { entityState: 4, _Entity: this.entity.name, actionId: id }
          });
          this.groupedActions[groupIndex].items[itemIndex].checked = true;
        }
      }
      else {
        const currentState = (this.instance[actionIndex].entityState);
        if (evt) {
          //Want to turn on a deleted one put on unchanged
          this.$store.commit('SET_INSTANCE_PATH', { path: `${this.path}[${actionIndex}].entityState`, value: 0 });
          this.groupedActions[groupIndex].items[itemIndex].checked = true;
        } else {
          //Want to delete one, put on delete if unchanged
          this.$store.commit('SET_INSTANCE_PATH', { path: `${this.path}[${actionIndex}].entityState`, value: 2 });
          this.groupedActions[groupIndex].items[itemIndex].checked = false;
          //Delete completelly if previously was added
          if (currentState === 4) {
            const _instance = [...this.instance];
            _instance.splice(actionIndex, 1);
            this.$store.commit('SET_INSTANCE_PATH', { path: `${this.path}`, value: _instance });
          }
        }
      }
    },
    foundInInstance(id) {
      return !_.isEmpty(_.find(this.instance.filter(x => x.deletedAt == null), ['actionId', id]));
    },
    async load () {
      try {
        ({ data: { data: this.actions } } = await axios.get('Action', { params: { withoutGlobalBusinessScope: true, pageSize: -1 } }));
        this.groupedActions = this.groupActions(this.actions);
      } catch (e) {
        console.log(this.$cleanString(e))
      } finally {
        this.loading = false
      }
    }
  },
  async created() {
    await this.load();
  },
}
</script>

